import { useTranslation } from 'react-i18next'

export const OrDelimiter = () => {
  const { t } = useTranslation()

  return (
    <div className="relative text-center uppercase">
      <div className="absolute left-0 top-1/2 h-0.5 w-full rounded-full bg-[linear-gradient(to_right,_theme(colors.slate.400)_0%,_theme(colors.slate.400)_43%,_transparent_43%,_transparent_57%,_theme(colors.slate.400)_57%,_theme(colors.slate.400)_100%)] text-center uppercase" />
      {t('or')}
    </div>
  )
}
